import Executive from './Executive';

export default Executive;